// noinspection ES6UnusedImports
import React, {Children} from 'react';
import ResponsiveImage from '@core/scripts/templates/ResponsiveImage.jsx';
import {Typography} from '@bonprix/design-system';

export default function SliderRecommendationItems({
    className = 'recommendations',
    items,
    imagesOnly,
    onSlideClicked,
    onLinkClicked,
    multiplePricesText,
    soldOutText,
    children,
}) {
    const renderFormerPrice = (price) => {
        if (!price?.former) {
            return null;
        }

        return (
            <>
                <span className={`${className}__former-price`}>
                    <Typography component="span" variant="body1" color="text-on-background-mid" strikeThrough>
                        {price.former.uniquePrice ? null : multiplePricesText + ' '}
                        {price.former.value}
                    </Typography>
                </span>
                <span className={`${className}__price-reduction`}>
                    <Typography component="span" variant="body1" color="additional-sale">
                        -{price.current.reduction}%
                    </Typography>
                </span>
            </>
        );
    };

    return (
        <>
            {items?.map((item, index) => {
                const onClick = () => onSlideClicked?.(item);
                const onLinkClick = (event) => {
                    if (!onLinkClicked) {
                        return;
                    }
                    event.preventDefault();
                    onLinkClicked?.(item);
                };
                const {price, availabilityStatus} = item;
                const currentPrice = (
                    <div
                        className={
                            `${className}__price` +
                            (price.current.unknownPrice ? ' -unknown' : '') +
                            (price.former ? ' -reduced' : '')
                        }
                    >
                        {price.current.uniquePrice ? null : (
                            <div className={`${className}__multiple-prices`}>{multiplePricesText}</div>
                        )}
                        <Typography component="span" variant="h4">
                            {price.current.value}
                        </Typography>
                    </div>
                );
                const soldOut = availabilityStatus === 'SOLDOUT';

                return (
                    <div className={`${className}__slide`} key={index}>
                        <div className={`${className}__product`} onClick={onClick}>
                            <a href={item.productUrl} className={`${className}__slide-link`} onClick={onLinkClick}>
                                <div className={`${className}__item-image-wrapper`}>
                                    <ResponsiveImage
                                        image={item.responsiveImage}
                                        alt={item.title}
                                        className={`${className}__item-image` + (soldOut ? ' is-sold-out' : '')}
                                    />
                                    {soldOut && <div className={`${className}__item-availability`}>{soldOutText}</div>}
                                </div>
                                {!imagesOnly && (
                                    <>
                                        <Typography variant="body" component="div">
                                            {item.title}
                                        </Typography>
                                        <div className={`${className}__item-price`}>
                                            {currentPrice}
                                            {renderFormerPrice(price)}
                                        </div>
                                    </>
                                )}
                            </a>
                        </div>
                        {Children.map(children, (child) => React.cloneElement(child, {item: item}))}
                    </div>
                );
            })}
        </>
    );
}
